<div class="join-action-button">
  <button class="button-primary button-with-image" routerLink="/merchants/signup" routerLinkActive="active" ariaCurrentWhenActive="page" i18n>Join us now<div class="i-image-to-flip"><img src="assets/arrow-right.svg" /></div></button>
</div>
